<template>
    <div :class="['sw-column', component.attributes.label ? 'sw-mt-1' : 'mt-5']"
         :id="'sw-' + component.component + '-' + id">
        <JetLabel v-if="component.attributes.label" class="sw-mb-1" :value="component.attributes.label" />

        <input ref="fileInput"
               @change="handleFileChange"
               v-bind="component.attributes"
               :required="requiredInput"
               type='file'
               multiple
               class="hidden"
        />

        <SecondaryButton @click="$refs.fileInput.click()">{{ component.attributes.buttonName }}</SecondaryButton>

        <div v-if="warningNumberMessage" class="text-red-500 text-sm mt-2">{{ warningNumberMessage }}</div>
        <div v-if="warningSizeMessage" class="text-red-500 text-sm mt-2">{{ warningSizeMessage }}</div>
        <div v-if="selectedFileNames" class="mt-2 text-sm text-gray-600 space-y-1">

            <div v-for="fileName in selectedFileNames.split(',')" :key="fileName">
                <span class="truncate">{{ fileName }}</span>
                <button @click="removeFile(fileName)"
                        class="ml-2 text-gray-500 hover:text-red-600"
                        title="x">
                    <i class="fa fa-times align-middle"></i>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
import JetLabel from '@/Jetstream/Label.vue'
import SecondaryButton from "@/Jetstream/SecondaryButton.vue";
import Button from "@/Jetstream/Button.vue";

export default {
    name: "Upload",
    components:{
        Button,
        SecondaryButton,
        JetLabel
    },
    props:{
        edit:Boolean,
        title: String,
        id: String,
        component:{
            type:Object,
            required:true
        }
    },
    data() {
        return {
            isFileTooBig: false,
            selectedFileNames: '',
            selectedFilesMap: new Map(),
            buttonText: 'Datei auswählen',
            warningNumberMessage: '',
            warningSizeMessage: '',
        }
    },
    computed: {
        requiredInput: {
            get(){
                return this.component.attributes.required === '1' || this.component.attributes.required === true;
            },
            set(value) {
                this.component.attributes.required = value;
            }
        },
        maxFiles() {
            return parseInt(this.component.attributes.filesNumber || 3, 10);
        },
        maxSize() {
            return this.component.attributes.size && this.component.attributes.size !== '-'
                ? parseInt(this.component.attributes.size, 10) * 1024 * 1024
                : Infinity;
        }
    },
    methods: {
        handleFileChange(event) {
            this.warningNumberMessage = '';
            this.warningSizeMessage = '';

            const files = Array.from(event.target.files);
            console.log("files: ",files);
            if (!files.length) return;

            const remainingSlots = this.maxFiles - this.selectedFilesMap.size;

            if (this.maxFiles && files.length > remainingSlots) {
                this.warningNumberMessage = `Bitte laden Sie nicht mehr als ${this.maxFiles} Dateien hoch.`;
            }

            let currentTotalSize = 0;
            for (const file of this.selectedFilesMap.values()) {
                currentTotalSize += file.size;
            }

            let addedCount = 0;
            for (const file of files) {
                if (addedCount >= remainingSlots) break;

                const predictedTotalSize = currentTotalSize + file.size;
                if (predictedTotalSize > this.maxSize) {
                    this.warningSizeMessage = `Die Gesamtgröße der Dateien darf ${this.component.attributes.size} MB nicht überschreiten.`;
                    break;
                }

                if (!this.selectedFilesMap.has(file.name)) {
                    this.selectedFilesMap.set(file.name, file);
                    currentTotalSize += file.size;
                    addedCount++;

                    if (this.selectedFileNames === '') {
                        this.selectedFileNames = file.name;
                    } else {
                        this.selectedFileNames += ',' + file.name;
                    }
                }
            }

            this.$emit('updateContact', { id: this.component.id, value: Array.from(this.selectedFilesMap.values())});
            // this.$emit('updateContact', { id: this.component.id, value: event.target.files[0]});
            this.$refs.fileInput.value = '';
        },
        removeFile(fileName) {
            this.selectedFilesMap.delete(fileName);

            const nameList = this.selectedFileNames.split(',').filter(name => name !== fileName);
            this.selectedFileNames = nameList.join(',');

            this.$emit('updateContact', { id: this.component.id, value: Array.from(this.selectedFilesMap.values())});

            if (this.selectedFilesMap.size < this.maxFiles) {
                this.warningNumberMessage = '';
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>
